/*  L'intestazione con cui, in sviluppo, si dice al server chi si è.

    Sta in un modulo suo e non dentro `sessione.ts` per una ragione noiosa e concreta: il
    client HTTP deve leggere questo valore per metterlo in ogni richiesta, e `sessione.ts`
    usa il client HTTP per chiedere «chi sono». Metterli nello stesso file creerebbe un
    ciclo fra i due moduli — quel tipo di ciclo che funziona nove volte su dieci e alla
    decima lascia una variabile non inizializzata senza spiegare perché.

    Non è una credenziale: è un valore che il server accetta solo con
    `Autenticazione:Modo = Sviluppo`, e in quel modo l'applicazione si rifiuta di partire
    fuori dall'ambiente di sviluppo. Con Entra ID o con un'utenza a password questo file
    smette di servire.
*/

export const INTESTAZIONE_UTENTE = 'X-Utente';

const CHIAVE = 'teraworks.utente';

/*  Ricordato nel browser e non nella memoria della pagina perché deve sopravvivere a un
    ricarico: provare l'applicativo nei panni dell'operaio vuol dire girare fra le
    schermate, e riscegliere la persona a ogni F5 lo renderebbe inutile.  */
export function utenteDichiarato(): string | null {
  try {
    return window.localStorage.getItem(CHIAVE);
  } catch {
    // In navigazione anonima l'accesso può fallire: l'applicativo funziona comunque,
    // con l'utente predefinito del server.
    return null;
  }
}

export function dichiaraUtente(codice: string | null): void {
  try {
    if (codice === null) window.localStorage.removeItem(CHIAVE);
    else window.localStorage.setItem(CHIAVE, codice);
  } catch {
    /* senza memoria del browser si riparte dall'utente predefinito del server */
  }
}
